import { Leaf, MapPinned } from 'lucide-react';
import { PlusCircle, Facebook } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FACEBOOK_GROUP_URL } from './FacebookBanner';

/**
 * Loading State Component
 * Shown while boxes are being loaded
 */
export const LoadingState = () => (
  <div className="flex items-center justify-center h-full bg-green-50">
    <div className="text-center">
      <div className="animate-pulse mb-4">
        <Leaf className="w-16 h-16 text-green-500 mx-auto" />
      </div>
      <p className="text-gray-600">Loading honesty boxes...</p>
    </div>
  </div>
);

/**
 * Empty State Component
 * Shown when there are no boxes in the system
 */
export const EmptyState = ({ navigate }) => (
  <div className="flex items-center justify-center h-full bg-gradient-to-br from-green-50 to-white">
    <div className="text-center max-w-md px-4">
      <MapPinned className="w-20 h-20 text-green-300 mx-auto mb-4" />
      <h2 className="text-2xl font-bold text-gray-800 mb-2">No boxes found</h2>
      <p className="text-gray-600 mb-6">
        Be the first to add an honesty box in your area!
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          onClick={() => navigate('/submit-box')}
          className="bg-green-600 hover:bg-green-700"
          data-testid="empty-add-box-btn"
        >
          <PlusCircle className="w-4 h-4 mr-2" />
          Add a Box
        </Button>
        <a
          href={FACEBOOK_GROUP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="outline" className="w-full border-blue-500 text-blue-600">
            <Facebook className="w-4 h-4 mr-2" />
            Ask the Community
          </Button>
        </a>
      </div>
    </div>
  </div>
);
